import map from "lodash/map";
import { buildProfilesOptionsFetcher } from "PFApp/helpers/options/profiles_options";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Stack } from "PFComponents/containers";
import { Modal } from "PFComponents/modal";
import { Select } from "PFComponents/select";
import { Typography } from "PFComponents/typography";
import { useActivityEconomicsScenarioShare } from "PFCore/hooks/queries/activity/use_activity_economics_scenario_share";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { BasicProfile, Id } from "PFTypes";
import { Option } from "PFTypes/options";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type ShareScenarioModalProps = {
  scenarioId: Id;
  onClose: () => void;
};

export const ShareScenarioModal = ({ scenarioId, onClose }: ShareScenarioModalProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.economics.shareScenarioModal" });
  const { showGrowl } = useGrowlStoreActions();

  const { data: currentProfile } = useCurrentProfile();
  const { mutateAsync: shareScenario } = useActivityEconomicsScenarioShare(scenarioId);

  const [profiles, setProfiles] = useState<BasicProfile[]>([]);

  const handleShare = async () => {
    await shareScenario(map(profiles, "id"), {
      onSuccess: () => {
        showGrowl({ message: t("shareSuccess"), kind: "success" });
        onClose?.();
      },
      onError: () => {
        showGrowl({ message: t("shareError"), kind: "error" });
      }
    });
  };

  return (
    <Modal
      title={t("title")}
      onOK={handleShare}
      onClose={onClose}
      labelOK={t("okLabel")}
      disableOKButton={!profiles.length}
    >
      <Stack>
        <Select<BasicProfile>
          label={t("label")}
          fetchOptions={buildProfilesOptionsFetcher()}
          parseOptions={(options: Option<BasicProfile>[]) =>
            options.filter((item) => currentProfile.id !== item.id)
          }
          onChange={(options: Option<BasicProfile>[]) => setProfiles(options.map(({ original }) => original))}
          onClear={profiles.length > 0 ? () => setProfiles([]) : undefined}
          value={profiles.map(({ id }) => id)}
          dropdownId="share-scenario-modal"
          multiple
          isFetchingSelectedOptions={false}
        />
        <Typography variant="bodyBold">{t("disclaimerTitle")}</Typography>
        <Typography variant="bodyRegular">{t("disclaimer")}</Typography>
      </Stack>
    </Modal>
  );
};
